var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingCreditcardVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Payment/Visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-11-Copy-3",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(2.368000, 11.904000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.178941,5.21865018 C22.3586764,4.76534743 23.0455989,3.01852183 23.0455989,3.01852183 C23.0331472,3.03917996 23.2244449,2.56301358 23.3342872,2.26755076 L23.4815591,2.94588752 C23.4815591,2.94588752 23.8978039,4.82496931 23.9851886,5.21887073 L22.178941,5.21887073 L22.178941,5.21865018 Z M23.1678931,0.128 C22.6465494,0.128 22.2698834,0.285913446 22.0407857,0.798396982 L18.816,8 L21.1197995,8 L21.5676926,6.79374124 L24.3202005,6.79374124 L24.5759064,8 L26.624,8 L24.8322053,0.12822055 L23.1679672,0.12822055 L23.1678931,0.128 Z",
    id: "Fill-6",
    fill: "#333473"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#333473",
    points: "9.536 8 10.8800337 0.128 13.056 0.128 11.7120404 8 9.536 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.456,0.330500375 C19.0249539,0.170912967 18.3496384,0 17.5062906,0 C15.3566907,0 13.8425468,1.06827958 13.8295072,2.59877431 C13.817579,3.73000635 14.9103824,4.36100173 15.7359491,4.73798102 C16.5825568,5.12319708 16.8672784,5.3703737 16.8631295,5.71462654 C16.8578692,6.24244167 16.1867027,6.48373489 15.5613228,6.48373489 C14.6908586,6.48344072 14.2281767,6.36430173 13.5137426,6.07042557 L13.2334663,5.94496192 L12.928,7.70777767 C13.4361721,7.92767 14.3759089,8.11836592 15.3514304,8.128 C17.6376492,8.1274852 19.1224542,7.07244328 19.1391241,5.43759163 C19.147422,4.54191649 18.5677546,3.86025027 17.3127718,3.29809075 C16.5523288,2.93427559 16.0866093,2.69129089 16.0916473,2.32203357 C16.0916473,1.99484261 16.4860938,1.64485345 17.3374432,1.64485345 C18.0487656,1.63382206 18.5641243,1.78686418 18.9658314,1.94645159 L19.1604615,2.03727668 L19.456,0.330500375",
    id: "Fill-5",
    fill: "#333473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56932132,5.52416579 L5.37771771,4.44497675 C4.98072927,3.18698889 3.74864252,1.82585352 2.368,1.14388897 L4.28981527,8 L6.5933559,8 L10.048,0.128 L7.74497802,0.128 L5.56932132,5.52416579",
    id: "Fill-7",
    fill: "#333473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.128 L0,0.256143869 C2.73017023,0.91279782 4.6256071,2.57288719 5.376,4.48 L4.58706841,0.805257766 C4.45536982,0.303058311 4.05627197,0.145491008 3.5840247,0.128074114 L0,0.128",
    id: "Fill-8",
    fill: "#E9833A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingCreditcardVisa);
export default __webpack_public_path__ + "static/media/billing-creditcard-visa.5a31e9ea932eb2821cb311ab05365061.svg";
export { ForwardRef as ReactComponent };